import { useCallback, useState } from 'react'

import { JoinRequestResponse } from '@/lib/definitions/api.types'
import { FLAGS, useFeatureFlag } from '@/lib/hooks/useFeatureFlag'
import { useLoadMyInvitations } from '@/lib/queries/Membership.queries'

const DISMISSED_INVITATION_KEY = 'portal.dismissed-invitation'

interface CompanyInvitations {
  invitations: JoinRequestResponse[]
  hasInvitations: boolean
  dismissInvitations: () => void
}

export const useCompanyInvitations = (): CompanyInvitations => {
  const areMembershipsEnabled = useFeatureFlag(FLAGS.COMPANY_MULTI_ACCESS)
  const { data } = useLoadMyInvitations(areMembershipsEnabled)
  const invitations = data ?? []
  const [dismissedId, setDismissedId] = useState<string | null>(() =>
    sessionStorage.getItem(DISMISSED_INVITATION_KEY)
  )

  const pending = invitations[0]

  const dismissInvitations = useCallback(() => {
    if (!pending) return

    sessionStorage.setItem(DISMISSED_INVITATION_KEY, String(pending.id))
    setDismissedId(String(pending.id))
  }, [pending])

  return {
    invitations,
    hasInvitations: Boolean(pending) && String(pending.id) !== dismissedId,
    dismissInvitations,
  }
}
